import { Component, Inject, Input } from 'ng-metadata/core';
import * as angular from 'angular';

/**
 * @ngdoc directive
 * @name mwIconButton
 * @module mw.components.icon
 *
 * @description
 * `<mw-icon-button>` is a component used to display icon buttons.
 *
 * @param {string} [svg-src] - URL (or expression) used to load, cache, and display an external SVG.
 * @param {string} [svg-icon] - Icon name used for lookup of in the icon registry.
 * @param {string} [aria-label] - ARIA text.
 * @param {string} [tooltip] - Text of the tooltip.
 * @param {string} [tooltip-direction] - Where to be display the text.
 * @param {string} [size] - Size of the icon. Supported values include 'sm' and 'xs'.
 * @param {boolean} [hover] - Flag to allow icon button to have a hover effect.
 * @param {boolean} [is-disabled] - Flag to allow icon button to be disabled.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-icon-button svg-icon="meltwater:dashboard" aria-label="dashboard"></mw-icon-button>
 *   <mw-icon-button svg-src="icons/rainbow.svg" aria-label="rainbow"></mw-icon-button>
 *   <mw-icon-button svg-src="{{ $ctrl.getMyIcon() }}" aria-label="my icon"></mw-icon-button>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-icon-button',
    template: `
        <md-button class="md-icon-button {{::$ctrl.size ? 'mw-icon-button--' + $ctrl.size : ''}}" ng-disabled="$ctrl.isDisabled" ng-class="::{ 'mw-icon-button--hover': $ctrl.hover, 'mw-button--badged': $ctrl.$transclude.isSlotFilled('badgeSlot') }" aria-label="{{ ::$ctrl.ariaLabel }}" md-prevent-menu-close="true">
            <md-tooltip md-direction="{{::$ctrl.tooltipDirection}}" md-delay="500" ng-if="::$ctrl.tooltip != ''">
                <span translate>{{::$ctrl.tooltip}}</span>
            </md-tooltip>
            <mw-icon svg-icon="{{ ::$ctrl.svgIcon }}" svg-src="{{ ::$ctrl.svgSrc }}" aria-label="{{ ::$ctrl.ariaLabel }}" size="{{ ::$ctrl.size }}"></mw-icon>
            <ng-transclude ng-transclude-slot="badgeSlot"></ng-transclude>
        </md-button>
    `,
    legacy: {
        transclude: {
            'badgeSlot': '?mwBadge',
        },
    }
})
export class IconButtonComponent {
    @Input('@') svgIcon: string;
    @Input('@') svgSrc: string;
    @Input('@') ariaLabel: string;
    @Input('@') size: string = '';
    @Input('@') tooltip: string = '';
    @Input('@') tooltipDirection: string = '';
    @Input('<') hover: boolean = false;
    @Input('<') isDisabled: boolean = false;

    constructor(@Inject('$transclude') private $transclude: angular.ITranscludeFunction) {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/icon/icon-button.component.ts